import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "apply-for",
  "use": "apply-for-usage",
  "viewBox": "0 0 25.3 32.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.3 32.1\" id=\"apply-for\"><path d=\"M0 32.1l2.7-8.9L18.2 0 23 3.2 7.4 26.5 0 32.1zm2.7-5l-.6 2 1.7-1.3-1.1-.7zM3 26l1.7 1.1 1.9-1.4L20 5.6l-2.9-2L3.7 23.7 3 26zM17.7 2.7l2.9 2 .7-1.1-2.9-2-.7 1.1zm7.6 28.2H5.7v-1.1h19.6v1.1zm0-4.5H11.6v-1.1h13.7v1.1zM11.8 7.9l-.9-.7 4.3-5.9.9.7-4.3 5.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol